export default "__VITE_ASSET__8a4066f3__"